<template>
    <div class="mt-5 mb-5">
        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex justify-content-between align-items-center">
                    <p class="title-biblioteca">
                        Manuales de capacitación
                    </p>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-3"
                v-for="{ id, titulo, texto, fechaModificacion, linkManual } in manualesFilter" :key="id">
                <div class="card shadow">
                    <div class="d-flex justify-content-start align-items-center">
                        <div
                            style="width: 25px ; height: 25px; border-radius: 50%; background-color: #E8E9F0; margin-right: 10px;">
                        </div>
                        <h6 class="mb-0">Documento</h6>
                    </div>
                    <div class="card-body text-start p-0 mt-5">
                        <v-tooltip top v-if="titulo.length > 30 " max-width="300px">
                            <template v-slot:activator="{ on }" >
                                <h5 v-on="on" class="card-title" style="font-size: 20px; font-weight: 600;">{{
                                    titleFormated(titulo) }}
                                </h5>
                            </template>
                            <span v-if="titulo.length > 30 "> {{ titulo }}</span>
                        </v-tooltip>
                        <h5 v-else class="card-title" style="font-size: 20px; font-weight: 600;">{{
                                    titleFormated(titulo) }}
                                </h5>
                        <p class="card-text" style=" font-size: 14px;">{{ textFormated(texto) }}</p>
                        <p class="text-muted" style="font-size: 12px;">Fecha {{
                            fechaModificacion.split('T')[0].split('-').reverse().join('-') }}</p>

                    </div>
                    <div class="d-flex justify-content-end align-items-end">
                        <button class="button" @click="showManual(titulo, linkManual)" data-bs-toggle="modal"
                            data-bs-target="#modalArchivo" v-if="!isMobile">Ver pdf</button>
                        <a :href="linkManual" target="_blank" class="button" v-else>Ver pdf</a>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-3" v-if="manualesFilter.length > 3">
                <button class="button" @click="loadMore()" v-if="manuals.length > itemsToShow">Cargar más</button>
                <button class="button" @click="resetItemsShow()" v-else>Cargar menos</button>
            </div>
        </div>
        <!-- Modal Archivo-->
        <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="modalArchivo" tabindex="-1"
            aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content modal-archivo">
                    <div class="modal-header modal-archivo__encabezado">
                        <h2 class="modal-title" style="font-size: 24px;">{{ currentManual.title }}</h2>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body-2" style="height:800px">
                        <iframe width="100%" height="100%" id="iframeDocumento" class="pdf-archivo" :src="currentManual.url"
                            type="content"></iframe>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="button modal-archivo__boton" data-bs-dismiss="modal">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        manuals: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentManual: { title: '', url: '' },
            itemsToShow: 4,
            search: ''

        }
    },
    computed: {
        manualesFilter() {
            const search = this.search.toLowerCase();
            const filteredManuales = this.manuals.filter(manual => {
                return manual.titulo.toLowerCase().includes(search);
            }).slice(0, this.itemsToShow);
            return filteredManuales;
        },
        isMobile() {
            return typeof window.orientation !== "undefined" || navigator.userAgent.indexOf("Mobile") !== -1;
        }
    },
    methods: {
        showManual(title, url) {
            this.currentManual.title = title
            this.currentManual.url = url
        },
        loadMore() {
            this.itemsToShow += 4;
        },
        resetItemsShow() {
            this.itemsToShow = 4
        },
        textFormated(text, limit = 145) {
            if (text.length > limit) text = text.slice(0, limit - 3) + "...";
            return text;
        },
        titleFormated(title, limit = 30) {
            if (title.length > limit) title = title.slice(0, limit - 3) + "...";
            return title;
        }
    }
}
</script>

<style lang="scss" scoped>
.button {
    background-color: #b8725a !important;
    color: white;
    border-radius: 5px;
    border: 0;
    font-size: 14px;
    padding: 10px;
    max-width: 260px;
    width: 150px;
    text-decoration: none;
}

.card {
    height: 275px;
    padding: 15px;
    color: #151965;
}

.title {
    font-size: 24px;
    font-weight: bold;
}

@media only screen and (max-width: 1024px) {

    .card {
        height: auto;

    }

    .title {
        font-size: 16px;
    }
}
</style>